import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Loader from "../../common/loader";
import { capitalizeFirstLetter, formateDate } from "../../../../utils/commonfunction";
import { useTranslation } from "react-i18next";
// import $ from "jquery";
import { Details } from "../../services/usermgmt.services";
import Breadcrums from "../../common/breadcrumbs";

const UsersView = (props) => {
  const navigate = useNavigate();
  const {t} = useTranslation();

  const params = useParams();
  // const [query] = useSearchParams();
  const [showdefault, setShowDefault] = useState({});

  const breadcrumbs = [
    { title: t("admin.cafes.link_dashboard"), url: "/admin/dashboard" },
    {
      title:  t("admin.cafes.link_cafes"),
      url: "/admin/cafe-management/cafe/list/1",
    },
    { title: t("admin.cafes.link_view"), url: "" },
  ];
  

  useEffect(() => {
    Details(params.id)
      .then((response) => {
        // console.log("View response-", response);
        setShowDefault(response && response.data ? response.data : []);
      })
      .catch((error) => {
        console.log("error=====>", error);
      });
  }, [params.id]);

  return (
    <>
   <div className="row row-sm">
        <div className="col-lg-12 col-md-12 animation_fade">
          <div className="card custom-card">
            <div className="">

              {showdefault && Object.keys(showdefault).length > 0 ? (
                <div className="row">
                  <div className="col-lg-12 form-group">
                    <table
                      id="simple-table"
                      className="table  table-bordered table-hover"
                    >
                      <tbody>
                        <tr>
                          <th>{t("admin.cafes.label_logo")}</th>
                          <td>
                            <img
                              src={
                                showdefault && showdefault.cafe_logo
                                  ? showdefault.cafe_logo
                                  : "N/A"
                              }
                              alt="profile"
                              style={{ height: "100px" }}
                            />
                          </td>
                        </tr>
                        <tr>
                          <th>{t("admin.cafes.label_trading_name")}</th>
                          <td className="text-capitalize">
                            {showdefault && showdefault.cafe_name
                              ? showdefault.cafe_name
                              : "N/A"}
                          </td>
                        </tr>

                        <tr>
                          <th>{t("admin.cafes.trading_id")}</th>
                          <td className="text-capitalize">
                            {showdefault && showdefault.id ? showdefault.id : "N/A"}
                          </td>
                        </tr>

                        <tr>
                          <th>{t("admin.cafes.label_email")}</th>
                          <td>
                            {showdefault && showdefault.email
                              ? showdefault.email
                              : "N/A"}
                          </td>
                        </tr>
                        <tr>
                          <th>{t("admin.cafes.label_address")}</th>
                          <td>
                            {showdefault && showdefault.address
                              ? capitalizeFirstLetter(showdefault.address)
                              : "N/A"}
                          </td>
                        </tr>
                        <tr>
                          <th>{t("admin.cafes.label_phone_number")}</th>
                          <td>
                            {showdefault && showdefault?.phone_number
                              ? showdefault.phone_number
                              : "N/A"}
                          </td>
                        </tr>
                        <tr>
                          <th>{t("admin.list_heading.list_heading_created_date")}</th>
                          <td>
                            {showdefault && showdefault.createdAt
                              ? formateDate(showdefault.createdAt)
                              : "N/A"}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                    </div>
                </div>
              ) : (
                <Loader />
              )}
            </div>
            <div className="mt-2 back-button mx-0">
              <button
                className="btn ripple btn-dark"
                type="button"
                onClick={() =>
                  navigate("/admin/cafe-management/cafe/list/1")
                }
              >
                <i className="ace-icon-solid ion-arrow-return-left bigger-110 mx-1"></i>
                {t("admin.button.btn_back")}
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default UsersView;
